import { jsx as e } from "react/jsx-runtime";

import { forwardRef as t } from "react";

import { INPUT_VARIANT_CLASSES as o } from "../../constants/index.js";

import r from "../../utils/classNames/index.js";

let a = !1;

const i = t((({variant: t, multiline: i = !1, autoComplete: s, className: n, ...l}, p) => {
    const u = t && o[t];
    /**
     * Otherwise typescript does not swallow conditionally typed ref. Minifier makes it look good again
     * TODO: Figure out how to conditionally type shallow ref
     * */
    return "production" !== process.env.NODE_ENV && (void 0 === l["aria-invalid"] || a || (console.warn("You should not pass aria-invalid prop to <Input /> directly. It is computed from variant === error."), 
    a = !0), s || console.warn('autoComplete should be passed to <input /> for better user experience. If no autoComplete is needed - write autocomplete="off"')), 
    s ||= "off", e(i ? "textarea" : "input", {
        ...l,
        autoComplete: s,
        "aria-invalid": "error" === t ? "true" : "false",
        className: r("input", n, u),
        ref: p
    });
}));

export { i as default };
//# sourceMappingURL=index.js.map
